import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from 'src/app/core/config/configuration.service';
import { HttpParamsFromListRequestDTO, ListRequestDTO, ListResponseDTO, TestSummaryDTO } from '../';

@Injectable()
export class PurchaseOrdersProxy {
    constructor(private http: HttpClient, private configurationService: ConfigurationService) {}

    async get(
        options: ListRequestDTO & {
            practiceId?: string;
            isClosed?: boolean;
            isOpen?: boolean;
        }
    ): Promise<ListResponseDTO<PurchaseOrderSummaryDTO>> {
        const url = this.configurationService.APIURL + '/api/purchaseOrders';
        let params = HttpParamsFromListRequestDTO(options);
        if (options.practiceId) {
            params = params.append('practiceId', String(options.practiceId));
        }
        if (options.isClosed) {
            params = params.append('isClosed', String(options.isClosed));
        }
        if (options.isOpen) {
            params = params.append('isOpen', String(options.isOpen));
        }
        return await this.http.get<ListResponseDTO<PurchaseOrderSummaryDTO>>(url, { params: params }).toPromise();
    }

    async create(practiceId: string, createPurchaseOrderDTO: CreatePurchaseOrderDTO) {
        const url = this.configurationService.APIURL + '/api/purchaseOrders';
        let params = new HttpParams();
        params = params.append('practiceId', String(practiceId));
        await this.http.post(url, createPurchaseOrderDTO, { params: params }).toPromise();
    }

    async close(practiceId: string, id: string, testReferenceToAmounts: { [key: string]: number }, message: string) {
        const url = this.configurationService.APIURL + '/api/purchaseOrders/' + id + '/close';
        let params = new HttpParams();
        params = params.append('practiceId', String(practiceId));
        const dto = <ClosePurchaseOrderStatusDTO>{ testReferenceToAmounts: testReferenceToAmounts, message: message };
        await this.http.put(url, dto, { params: params }).toPromise();
    }

    async export(purchaseOrderIds: string[]): Promise<Blob> {
        const url = this.configurationService.APIURL + '/api/purchaseOrders/export';
        return await this.http.post(url, purchaseOrderIds, { responseType: 'blob' }).toPromise();
    }
}

export interface CreatePurchaseOrderDTO {
    createdMessage: string;
    testReferenceToAmounts: { [key: string]: number };
}

interface ClosePurchaseOrderStatusDTO {
    testReferenceToAmounts: { [key: string]: number };
    message: string;
}

export interface PurchaseOrderSummaryDTO {
    id: string;
    practiceId: string;
    practiceName: string;
    createdBy: string;
    createdOn: Date | string;
    createdMessage: string;
    isClosed: boolean;
    closedOn: Date | string;
    closedBy: string;
    closeMessage: string;
    lines: PurchaseOrderLineSummaryDTO[];
}

export interface PurchaseOrderLineSummaryDTO {
    test: TestSummaryDTO;
    amountOrdered: number;
    amountShipped: number | null;
}
